export default __webpack_public_path__ + "static/media/upload.c25baabf.svg";